/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { Button, Form, Image, Table, Modal } from "react-bootstrap"
import ReassignModal from "./ReassignModal"
import { formatDate, moveItemBetweenUsers } from "../../../constant/utils"
import { useDispatch, useSelector } from "react-redux"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"
import AddEditUser from "./AddEditUser"
import ReassignAgencyModal from "./ReassignAgencyModal"
import { inviteContact } from "../../../data/contactSlice"
import { reassignApplicationToUser, reassignMultipleApplicationsToUser } from "../../../data/applicationSlice"
import Loader from "../../../components/Loader"

const UsersTable = ({
    contacts,
    agencyId,
    agencies,
    showAddEditUser,
    setShowAddEditUser,
    setCurrentUser,
    currentUser,
    handleShowInformation,
    getAgenciesList,
    contactAgencyId,
    setContactAgencyId
}) => {
    const [sectionsOpen, setSectionsOpen] = useState([])
    const [showReassignModal, setShowReassignModal] = useState(false)
    const [showReassignAgencyModal, setShowReassignAgencyModal] = useState(false)
    const [showReassignAgencyWarningModal, setShowReassignAgencyWarningModal] = useState(false)
    const { fetchStatus } = useSelector((state) => state.application)
    const { fetchStatus: agencyFetchStatus } = useSelector((state) => state.agency)
    const [selectedUser, setSelectedUser] = useState()
    const [reassignModalData, setReassignModalData] = useState({})
    const [showEditUserInfoModal, setShowEditUserInfoModal] = useState(false)
    const [switchingAgency, setSwitchingAgency] = useState(false)
    const [reassigningSelected, setReassigningSelected] = useState([])
    const [reassignAllApplications, setReassignAllApplications] = useState([])
    const [reassigningSelectedContact, setReassigningSelectedContact] = useState(null)

    const dispatch = useDispatch()

    const handleSwitchAgency = (userId) => {
        const userWithApplications = contacts.find((user) => user.id === userId)
        if (userWithApplications && userWithApplications?.applications?.length > 0) {
            setShowReassignAgencyWarningModal(true)
        } else {
            setShowEditUserInfoModal(true)
            setSwitchingAgency(true)
            setSelectedUser(userWithApplications)
            setCurrentUser(userWithApplications)
        }
    }

    useEffect(() => {
        if (!sectionsOpen.includes(true)) {
            setSectionsOpen(Array(contacts?.length).fill(false))
        }
    }, [contacts?.length])

    useEffect(() => {
        if (!reassigningSelected?.length) {
            setReassigningSelectedContact(null)
        }
    }, [reassigningSelected])

    const toggleSection = (index) => {
        setSectionsOpen((prevState) => {
            const updatedSections = [...prevState]
            updatedSections[index] = !updatedSections[index]
            return updatedSections
        })
    }

    const handleReassignModalClose = () => {
        setReassignModalData({})
        setShowReassignModal(false)

        if (reassigningSelected?.length > 0) {
            setReassigningSelected([])
        }
    }

    const handleReassignModalShow = (applicationId, userId, allApplications) => {
        if (allApplications?.length > 0) {
            setReassignAllApplications(allApplications.map((app) => app.id))
        }
        setReassignModalData({ applicationId, userId, agencyId })
        setShowReassignModal(true)
    }

    const handleReassignAgencyModalClose = () => {
        setReassignModalData({})
        setShowReassignAgencyModal(false)
    }

    const handleReassignAgencyModalShow = () => {
        setShowReassignAgencyModal(true)
    }

    const handleReAssignee = (selectedUserId) => {
        if (reassignAllApplications?.length > 0 || reassigningSelectedContact) {
            const payload = {
                applicationIds:
                    reassignAllApplications?.length > 0 ? [...reassignAllApplications] : [...reassigningSelected],
                userId: selectedUserId
            }
            dispatch(reassignMultipleApplicationsToUser(payload)).then(({ payload }) => {
                if (payload?.succeeded) {
                    if (reassignAllApplications?.length > 0) setReassignAllApplications([])
                    getAgenciesList().then(() => {
                        handleReassignModalClose()
                    })
                } else {
                    handleReassignModalClose()
                }
            })
        } else {
            const payload = moveItemBetweenUsers(
                selectedUserId,
                reassignModalData,
                JSON.parse(JSON.stringify(agencies))
            )

            dispatch(reassignApplicationToUser(payload)).then(({ payload }) => {
                if (payload?.succeeded) {
                    getAgenciesList().then(() => {
                        handleReassignModalClose()
                    })
                } else {
                    handleReassignModalClose()
                }
            })
        }
    }

    const handleEditUser = (user) => {
        setCurrentUser(user)
        setShowAddEditUser(true)
    }

    const handleCloseReassignAgencyWarningModal = () => {
        setShowReassignAgencyWarningModal(false)
    }

    const handleUpdateUser = (user) => {
        // TODO: We will update the user from here by calling the API
        setShowAddEditUser(false)
    }

    const handleInvitation = (contactId) => {
        if (contactId) {
            dispatch(inviteContact(contactId))
        }
    }

    return (
        <>
            <Loader show={fetchStatus === "loading" || agencyFetchStatus === "loading"} />
            <AddEditUser
                show={showAddEditUser || switchingAgency}
                hide={(isSwitch) => {
                    if (isSwitch) {
                        handleReassignAgencyModalShow()
                    }
                    setSwitchingAgency(false)
                    setShowAddEditUser(false)
                    setContactAgencyId("")
                }}
                currentUser={currentUser}
                setCurrentUser={setCurrentUser}
                updateUser={handleUpdateUser}
                getAgenciesList={getAgenciesList}
                contactAgencyId={contactAgencyId}
                switchingAgency={switchingAgency}
            />

            <Modal
                show={showReassignAgencyWarningModal}
                onHide={handleCloseReassignAgencyWarningModal}>
                <Modal.Body>
                    Please reassign all applications for this contact before moving to another agency.
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleCloseReassignAgencyWarningModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Table
                striped
                bordered
                className="mt-3">
                <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Last Login</th>
                        <th className="text-center">Re-invite</th>
                        <th className="text-center">Active</th>
                        <th className="text-center">Edit</th>
                        <th style={{ width: "80px" }}>Switch Agency</th>
                    </tr>
                </thead>
                <tbody>
                    {sectionsOpen.map((isOpen, index) => {
                        return (
                            <React.Fragment key={index}>
                                <tr>
                                    <td>
                                        <span
                                            className="site-tank-toggle cursor-pointer"
                                            onClick={() => toggleSection(index)}>
                                            {isOpen ? (
                                                <Image src={"/icons/down-arrow.svg"} />
                                            ) : (
                                                <Image src={"/icons/right-arrow.svg"} />
                                            )}
                                        </span>
                                        {contacts?.[index]?.firstName}
                                    </td>
                                    <td className="d-flex align-items-center  ">
                                        {contacts?.[index]?.lastName}
                                        <FontAwesomeIcon
                                            className="mx-2 cursor-pointer"
                                            icon={byPrefixAndName.fal["circle-info"]}
                                            onClick={() => handleShowInformation(contacts?.[index].id, "contact")}
                                        />
                                    </td>
                                    <td>{contacts?.[index]?.email}</td>
                                    <td>{formatDate(contacts?.[index]?.lastLoginDateTimeUtc, true)}</td>
                                    <td className="text-center">
                                        <Button
                                            variant="light"
                                            className="btn-sm"
                                            onClick={() => handleInvitation(contacts?.[index]?.id)}
                                            disabled={contacts?.[index]?.hasPassword}>
                                            <FontAwesomeIcon
                                                icon={byPrefixAndName.fal["envelope"]}
                                                style={{ color: "#000000" }}
                                            />
                                        </Button>
                                    </td>
                                    <td className="text-center">
                                        {contacts?.[index]?.active && (
                                            <FontAwesomeIcon icon={byPrefixAndName.fal["check"]} />
                                        )}
                                    </td>
                                    <td className="text-center">
                                        <Button
                                            variant="light"
                                            className="me-2 btn-sm "
                                            onClick={() => handleEditUser(contacts?.[index])}>
                                            <FontAwesomeIcon
                                                icon={byPrefixAndName.fal["pen-to-square"]}
                                                style={{ color: "#000000" }}
                                            />
                                        </Button>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Button
                                            className="btn-sm"
                                            variant="light"
                                            onClick={() => handleSwitchAgency(contacts?.[index]?.id)}>
                                            <FontAwesomeIcon
                                                icon={byPrefixAndName.fal["share"]}
                                                style={{ color: "#000000" }}
                                            />
                                        </Button>
                                    </td>
                                </tr>
                                {isOpen && (
                                    <tr>
                                        <td
                                            colSpan="5"
                                            className="py-2 px-5">
                                            {reassigningSelected?.length > 0 &&
                                                contacts?.[index]?.id === reassigningSelectedContact && (
                                                    <Button
                                                        variant="primary"
                                                        className="mb-2"
                                                        onClick={() => {
                                                            handleReassignModalShow(
                                                                reassigningSelected[0],
                                                                contacts?.[index]?.id
                                                            )
                                                        }}>
                                                        Reassign Selected
                                                    </Button>
                                                )}
                                            {contacts?.[index]?.applications?.length > 0 && (
                                                <Button
                                                    variant="primary"
                                                    className={`mb-2 ${
                                                        reassigningSelected?.length > 0 &&
                                                        contacts?.[index]?.id === reassigningSelectedContact
                                                            ? "ms-2"
                                                            : ""
                                                    }`}
                                                    onClick={() => {
                                                        handleReassignModalShow(
                                                            reassigningSelected[0],
                                                            contacts?.[index]?.id,
                                                            contacts?.[index]?.applications
                                                        )
                                                    }}>
                                                    Reassign All
                                                </Button>
                                            )}
                                            <Table
                                                striped
                                                bordered>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "40px" }}></th>
                                                        <th>Title</th>
                                                        <th>Type</th>
                                                        <th style={{ width: "80px" }}>Reassign</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {contacts?.[index]?.applications?.map((item, itemIndex) => (
                                                        <tr
                                                            key={itemIndex}
                                                            className="centered-row">
                                                            <td className="text-center">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id="reassigningSelected"
                                                                    name="reassigningSelected"
                                                                    checked={reassigningSelected?.includes(item.id)}
                                                                    onChange={(e) => {
                                                                        if (
                                                                            reassigningSelectedContact ===
                                                                            contacts?.[index]?.id
                                                                        ) {
                                                                            setReassigningSelected((prevState) => {
                                                                                if (e.target.checked) {
                                                                                    return [...prevState, item.id]
                                                                                }
                                                                                return prevState.filter(
                                                                                    (id) => id !== item.id
                                                                                )
                                                                            })
                                                                            setReassigningSelectedContact(
                                                                                contacts?.[index]?.id
                                                                            )
                                                                        } else {
                                                                            setReassigningSelected((prevState) => {
                                                                                if (e.target.checked) {
                                                                                    return [item.id]
                                                                                }
                                                                                return prevState.filter(
                                                                                    (id) => id !== item.id
                                                                                )
                                                                            })
                                                                            setReassigningSelectedContact(
                                                                                contacts?.[index]?.id
                                                                            )
                                                                        }
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{item.firstNamedInsured}</td>
                                                            <td>{item.type}</td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <Button
                                                                    className="btn-sm"
                                                                    variant="light"
                                                                    onClick={() =>
                                                                        handleReassignModalShow(
                                                                            item.id,
                                                                            contacts?.[index]?.id
                                                                        )
                                                                    }>
                                                                    <FontAwesomeIcon
                                                                        icon={byPrefixAndName.fal["share"]}
                                                                        style={{ color: "#000000" }}
                                                                    />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        )
                    })}
                </tbody>
            </Table>

            <ReassignModal
                show={showReassignModal}
                onHide={handleReassignModalClose}
                users={reassignModalData?.userId && contacts.filter((user) => user.id != reassignModalData?.userId)} // Pass the contacts array to the ReassignModal
                onPressSubmit={(selectedUserId) => handleReAssignee(selectedUserId)}
                isLoading={fetchStatus === "loading" || agencyFetchStatus === "loading"}
            />
            <ReassignAgencyModal
                show={showReassignAgencyModal}
                onHide={handleReassignAgencyModalClose}
                agencies={agencies}
                agencyId={agencyId}
                selectedUser={selectedUser}
                getAgenciesList={getAgenciesList}
            />
        </>
    )
}

export default UsersTable
